var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "grid-view parent-wrapper-writeoff",
      style: _vm.dialogHeight ? _vm.dialogHeight : ""
    },
    [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c("search-item", {
            ref: "searchItem",
            attrs: {
              "show-more-scheme": true,
              "show-simple": _vm.showSimple,
              "is-append-query": _vm.isAppendQuery,
              "expand-adv": true,
              "sim-url": "",
              "adv-url": "",
              "auto-init": _vm.searchItemAutoInit,
              "custom-search-items": _vm.customSearchItems,
              "is-simple-query": _vm.isSimpleQuery,
              "custom-sim-query-placeholder": _vm.customSimQueryPlaceholder,
              "config-module": _vm.configModule,
              "grid-config-module": _vm.gridConfigModule,
              "col-settings": _vm.isDialog
                ? { span: 12 }
                : {
                    xs: 12,
                    sm: 12,
                    md: 12,
                    lg: 8,
                    xl: 6
                  }
            },
            on: {
              "update:isSimpleQuery": function($event) {
                _vm.isSimpleQuery = $event
              },
              "update:is-simple-query": function($event) {
                _vm.isSimpleQuery = $event
              },
              query: _vm.queryBtnClickHandler,
              advToggle: _vm.scrollCallback,
              perConfigChange: function(value) {
                _vm.perConfigName = value
              },
              refreshGrid: function() {
                _vm.gridRefreshId += 1
              },
              defaultSearchItemsChange: function(value) {
                _vm.defaultSearchItems = value
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "operations",
                  fn: function() {
                    return [
                      _vm._t("operations"),
                      _vm.cargoGridStateBtn
                        ? _c("cargo-grid-state-btn", {
                            attrs: {
                              "grid-params": _vm.gridParams,
                              "config-module": _vm.gridConfigModule
                            }
                          })
                        : _vm._e()
                    ]
                  },
                  proxy: true
                },
                {
                  key: "searchAreaHeader",
                  fn: function() {
                    return [_vm._t("searchAreaHeader")]
                  },
                  proxy: true
                }
              ],
              null,
              true
            )
          }),
          _c(
            "div",
            {
              staticClass: "section grid-wrapper",
              style: _vm.gridHeight ? _vm.gridHeight : ""
            },
            [
              _c("cargo-ag-grid-wrapper", {
                style: _vm.gridHeight ? _vm.gridHeight : "",
                attrs: {
                  no: "grid",
                  "config-module": _vm.gridConfigModule,
                  "per-config-name": _vm.perConfigName,
                  "refresh-id": _vm.gridRefreshId,
                  "grid-params": _vm.gridParams,
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData,
                  "show-row-groups": _vm.dataListDragGroup
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.gridParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.gridParams = $event
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "pagination-wrapper",
              attrs: { id: "footer-wrapper-tab-writeoff" }
            },
            [
              _vm.showChargeCurrencyTotalGroup
                ? _c(
                    "div",
                    {
                      class: [_vm.shouldFixed ? "fixedBottom" : ""],
                      staticStyle: {
                        display: "flex",
                        "justify-content": "flex-end",
                        "flex-wrap": "wrap",
                        "margin-top": "5px"
                      }
                    },
                    [
                      _c("span", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.dataShow &&
                              _vm.totalAmountToCurrency.selectionCountLabel,
                            expression:
                              "dataShow && totalAmountToCurrency.selectionCountLabel"
                          }
                        ],
                        domProps: {
                          textContent: _vm._s(
                            _vm.totalAmountToCurrency.selectionCountLabel
                          )
                        }
                      }),
                      _vm.reCalc
                        ? _c("charge-currency-total-group", {
                            key: "chargeCurrencyTotalGroup",
                            attrs: {
                              "ar-field": "ar",
                              "currency-field": "currency",
                              "data-field": "amount",
                              "amount-to-currency": _vm.localCurrency,
                              "rate-field": "rate",
                              type: "revenueAbs",
                              "amount-to-currency-label": _vm.$t(
                                "Clearing.Equivalent"
                              ),
                              "data-provider":
                                _vm.totalAmountToCurrency.dataProvider,
                              "arap-group": _vm.arapGroup,
                              "show-wht": _vm.showWht
                            }
                          })
                        : _vm._e(),
                      _vm.reCalc && _vm.viewSource === "tabWriteOffList"
                        ? _c("actual-charge-sum-by-currency", {
                            key: "chargeSumByCurrency",
                            attrs: {
                              "data-provider":
                                _vm.totalAmountToCurrency.dataProvider
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.appendQuery,
                      expression: "appendQuery"
                    }
                  ],
                  staticClass: "pagination-container"
                },
                [
                  _c("el-pagination", {
                    staticStyle: { "text-align": "left" },
                    attrs: {
                      no: "left-pagination",
                      total: _vm.pageConditions.total,
                      layout: "total"
                    }
                  })
                ],
                1
              ),
              _c("cargo-pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.appendQuery,
                    expression: "!appendQuery"
                  }
                ],
                attrs: {
                  no: "pagination",
                  "config-module": _vm.gridConfigModule,
                  total: _vm.pageConditions.total,
                  page: _vm.pageConditions.pageNum,
                  limit: _vm.pageConditions.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.pageConditions, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.pageConditions, "pageSize", $event)
                  },
                  pagination: _vm.query
                }
              })
            ],
            1
          ),
          _vm.pushLogDialog.visible
            ? _c("push-log-dialog-ql", {
                attrs: {
                  visible: _vm.pushLogDialog.visible,
                  uuid: _vm.pushLogDialog.uuid
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(_vm.pushLogDialog, "visible", $event)
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }